import { string } from "yup"
import { RequiredStringSchema } from "yup/lib/string"

export const requiredString = (message: string): RequiredStringSchema<string | undefined> => string().required(message)
